import type { ComponentType } from 'react';

/**
 * A slot-name → React component map, populated by the Shell from federated remotes.
 * The Shell resolves component classes at runtime; the host app renders them
 * in named positions.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PluginSlots = Record<string, ComponentType<any>>;

/**
 * A single component to inject from a plugin remote into a named slot.
 */
export interface PluginComponentConfig {
  /** Key in the remote's MF exposes map (e.g. 'AiChat') */
  exposedName: string;
  /** Slot name the host app will use to render this component */
  slot: string;
}

/**
 * A plugin remote declaration — which remote and which of its components to inject.
 */
export interface PluginConfig {
  /** MF remote name (matches the federation config `name`) */
  remoteName: string;
  /** remoteEntry.js URL — registered at runtime */
  entry: string;
  /** Components to resolve and inject into the host */
  components: PluginComponentConfig[];
}
